import { Box } from "@mui/material";
import { getMailReminderSent } from "api/services/notifications";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { ResType } from "types";
import Table, { ColumnType } from "components/Table";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { snack } from "components/toast";

const ReminderSent = () => {
  const [result, setResult] = useState("");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const navigate = useNavigate();

  // const { data, isLoading }: ResType = useQuery(
  //   ["remindersent", page, pageCount], // include page & limit in key
  //   () => getMailReminderSent({ limit: pageCount, offset: page * pageCount }),
  // );
  const { data, isLoading }: ResType = useQuery(
    [
      "remainer-sent",
      {
        limit: pageCount,
        offset: page * pageCount,
      },
    ],
    getMailReminderSent,
    {
      onSuccess: (res: any) => {
        console.log(res?.data);
      },
      onError: (err: any) => {
        if (!err?.error) {
          snack.error("An error occurred while reminders data");
        }
      },
    }
  );

  const handleRowClick = (rowData) => {
    // pass the reminder id or whole data
    navigate(`/communication/reminder-details/${rowData.id}`, { state: rowData });
  };

//   const rows = data?.[0] || []; // the rows
//   const totalCount = data?.data?.[1] || 0; // total count for pagination

  const totalCount = data?.data?.[1];

  const columns = [
    { key: "reminderType", title: "Reminder Type" },
    {
      key: "createdAt",
      title: "Created At",
      default: true,
      sort: true,
      active: false,
      render: (rowData) =>
        moment(rowData?.createdAt).utcOffset("+05:30", true).format("DD-MM-YYYY h:mm:ss A"),
    },
    {
      key: "clientCount",
      title: "No. of Clients",
      render: (rowData) => rowData?.clientDetails?.length || 0,
    },
  ];

  return (
    <Box px={1}>
      <Table
        sx={{ mt: 3 }}
        data={data?.data[0]}
        columns={columns}
        // sortHandler={}
        pagination={{ totalCount, page, setPage, pageCount, setPageCount }}
        onRowClick={handleRowClick}
      />
    </Box>
  );
};

export default ReminderSent;
